export default __webpack_public_path__ + "static/test6-43eb8577b23265d9ac49c27c24462d12.jpeg";